import { apiClient } from '@lib/axios';
import type { SearchResponse } from '@appTypes/shell';

export const searchService = {
  search: (q: string, signal?: AbortSignal) =>
    apiClient.get<SearchResponse>('/search', { params: { q }, signal }),
};
